import { Component } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LanguageService } from 'src/app/services/language.service';
import { ListFields } from '../listfields';
import { UtilsService } from 'src/app/services/utils.service';
import { SettingsService } from 'src/app/services/settings.service';
import { ConfigurationParsed } from '../configuration/configuration';
import { FormControl } from '@angular/forms';
import { MultipleSearchPropertyPipe } from 'src/app/pipes/multiple-search-property.pipe';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-unassigned-bikes',
  templateUrl: './unassigned-bikes.component.html',
  styleUrl: './unassigned-bikes.component.scss',
  standalone: false
})
export class UnassignedBikesComponent {

  public unassignedBikeList: any[] = [];
  public unassignedFields: ListFields[] = [
    { Id: 0, FieldName: "BikeSerial", Uppercase: false, DisplayName: this.languageService.languageJSON.ManageBikes_BikeID, SearchBy: true, GroupBy: true },
    { Id: 2, FieldName: "CreatedAt", Uppercase: false, DisplayName: this.languageService.languageJSON.ManageBikes_CreatedAt, SearchBy: false, GroupBy: true },
    { Id: 3, FieldName: "OEMName", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentDetails_OEMName, SearchBy: true, GroupBy: true }
  ];
  public order: string = this.unassignedFields[0].FieldName;
  public reverse: boolean = false;
  public caseInsensitive: boolean = true;
  public searchByList: any = {};
  public loading: boolean = false;
  public page: number = 1;
  public totalItems: number = 0;
  public itemsPerPage: number = this.settingsService.getItemsPerPage();
  public paginationValues: number[] = this.settingsService.getPaginationValues();
  public lastSelectedComponentId: number = -1;
  public configurationList: ConfigurationParsed[] = [];
  public approvalControl = new FormControl('false');

  constructor(private httpService: HttpService, public languageService: LanguageService, private utilsService: UtilsService,
    private settingsService: SettingsService, private multipleSearchPropertyPipe: MultipleSearchPropertyPipe,
    private datePipe: DatePipe) {
  }

  ngOnInit() {
    this.loading = true;
    this.httpService.getConfigurationList().subscribe((resp: any) => {
      this.loading = false;
      if (resp?.success) {
        this.configurationList = resp.data.map((el: any) => {
          const configurationEL: ConfigurationParsed = {
            Id: el.id,
            BikeCount: el.bike_count,
            ConfigName: el.config_name,
            ConfigId: el.config_id,
            OE: el.oe,
            Brand: el.brand,
            Comment: el.comment,
            BikeModelName: el.bike_model_name
          }

          return configurationEL;
        });

        this.configurationList.unshift({
          Id: 0,
          BikeCount: 0,
          ConfigName: "Empty",
          ConfigId: "",
          OE: 0,
          Brand: "",
          Comment: "",
          BikeModelName: ""
        });

        this.initUnassignedBikeList();
      }
    }, (error) => {
      this.loading = false;
    });
  }

  public initUnassignedBikeList(): void {
    this.loading = true;
    forkJoin([this.httpService.getUnassignedBikeList(), this.httpService.getOEOptionsList(1, 0)])
      .subscribe((resp: any) => {
        this.loading = false;
        if (resp[0].success) {
          this.unassignedBikeList = resp[0].data.map((el: any) => {
            const componentEl = {
              BikeSerial: el.serial_id,
              CreatedAt: this.datePipe.transform(new Date(el.created_at), "long") || "",
              OEMName: this.utilsService.getOEMName(el.OEM_ID, resp[1])
            };
            return componentEl;
          });
          this.totalItems = this.unassignedBikeList.length;
        }
      }, () => {
        this.loading = false;
      });
  }

  public getPaginationText(): string {
    return this.utilsService.getPaginationText(this.itemsPerPage, this.page, this.totalItems);
  }

  public onPageChangeEvent(event: number) {
    if (event != this.page) {
      this.page = event;
    }
  }

  public itemsPerPageChanged(): void {
    this.page = 1;
  }

  public onSearchChanged(event: any) {
    this.searchByList = event;
    this.totalItems = this.multipleSearchPropertyPipe.transform(this.unassignedBikeList, this.searchByList).length;
  }

  /** Changing table ordering by selected field */
  public setOrder(value: string, groupBy: boolean) {
    if (groupBy) {
      if (this.order === value) {
        this.reverse = !this.reverse;
      }

      this.order = value;
    }
  }
}
